import { render, staticRenderFns } from "./FactoryProductSaleLayout.vue?vue&type=template&id=6d701da4&scoped=true&"
import script from "./FactoryProductSaleLayout.vue?vue&type=script&lang=js&"
export * from "./FactoryProductSaleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d701da4",
  null
  
)

export default component.exports